// src/components/sections/FeaturesSection.jsx
// Features showcase section

import React from 'react';
import { FEATURES } from '../../config/constants';
import Card from '../common/Card';

const FeaturesSection = () => {
  return (
    <section id="features" className="relative z-10 px-6 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 dark:text-white">What We Do Best 💪</h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">Everything you need to dominate online</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES.map((feature, index) => (
            <Card key={index} variant="feature" className="feature-card">
              <div
                className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-2xl flex items-center justify-center text-4xl mb-4 shadow-lg`}
              >
                  {feature.emoji}
              </div>
              <h3 className="text-2xl font-bold mb-3 text-gray-900">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-gray-700">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
